import { queryOptions, useQuery } from '@tanstack/react-query'
import {
  fetchRewardsProgram,
  fetchRewardsSavings,
} from '@/features/account/services/RewardsPrograms/fetchers'
import { useSession } from '@/features/authentication/utils/authentication/hooks/useSession'
import { useFeatureFlags } from '@/features/shared/services/FeatureFlags/useFeatureFlags'

export const RewardsProgramsQuery = 'Rewards Programs'
export type RewardsProgramsQueryKey = readonly [
  typeof RewardsProgramsQuery,
  { isBFFLoyalty: boolean },
]

export const rewardsProgramsQueryOptions = (isBFFLoyalty: boolean) =>
  queryOptions({
    queryKey: [RewardsProgramsQuery, { isBFFLoyalty }] as const,
    queryFn: fetchRewardsProgram,
  })
export const useQueryRewardsPrograms = (enabled = true) => {
  const { userId } = useSession()
  const { flags, status } = useFeatureFlags()
  return useQuery({
    ...rewardsProgramsQueryOptions(flags.bff_loyalty_migration),
    enabled: Boolean(userId) && enabled && status !== 'pending',
  })
}

export type RewardsProgramSavingsQueryKey = readonly [
  string,
  { storeId: number | null; userId: number | null; isBFFLoyalty: boolean },
]

export const rewardsProgramSavingsQueryOptions = ({
  storeId,
  userId,
  isBFFLoyalty,
}: {
  storeId: number
  userId: number | null
  isBFFLoyalty: boolean
}) =>
  queryOptions({
    queryKey: ['Rewards Program Savings', { storeId, userId, isBFFLoyalty }] as const,
    queryFn: fetchRewardsSavings,
  })

export const useQueryRewardsSavingsForStore = ({
  enabled,
  storeId,
}: {
  enabled: boolean
  storeId: number
}) => {
  const { userId } = useSession()
  const { flags, status } = useFeatureFlags()

  return useQuery({
    ...rewardsProgramSavingsQueryOptions({
      storeId,
      userId,
      isBFFLoyalty: flags.bff_loyalty_migration,
    }),
    enabled: Boolean(userId) && enabled && status !== 'pending',
  })
}
